import { TermsConfigActionTypes } from '../actions/termsConfigActions';
import { ILanguageTranslation } from './globalConfigReducer';
import ACTIONS_TYPES from '../../constants/types';
import { FixMeLater } from '../../temporary-types';

export interface ITermsConfigState {
  currentStep: number;
  active: boolean;
  acceptance: ITermAcceptance[];
  steps: ITermStep[];
}

export interface ITermAcceptance {
  code: string;
  accepted: boolean;
}

export interface ITermStep {
  code: string;
  title: ILanguageTranslation;
  text: ILanguageTranslation;
  checkBoxLabel: ILanguageTranslation;
  fullViewRequired: boolean;
  disabled: boolean;
  fieldConfigs?: FixMeLater;
}

const initialState: ITermsConfigState = {
  currentStep: 0,
  active: false,
  acceptance: [],
  steps: [],
};

export default function (state = initialState, action: TermsConfigActionTypes) {
  switch (action.type) {
    case ACTIONS_TYPES.SET_TERMS_CONFIG:
      return { ...state, ...action.payload };

    case ACTIONS_TYPES.SET_TERMS_NEXT_STEP:
      return { ...state, currentStep: state.currentStep + 1 };

    case ACTIONS_TYPES.SET_TERMS_ACCEPTANCE:
      return { ...state, acceptance: [...state.acceptance, action.payload] };

    default:
      return state;
  }
}
